import { memo } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import List from 'components/Common/List/List'

interface Props {
  roomType: App.PackageRoomType
  size?: 'small' | 'medium'
}

function LePackageUpgradeCardRoomDetails({ roomType, size = 'small' }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={12}>
      <BodyText variant={size} weight="bold">{intl.formatMessage({
        id: 'evZ_7bsnwDkyD0kGieW-',
        defaultMessage: 'About The Room',
      })}
      </BodyText>
      {roomType.description &&
        <BodyText variant={size}>{roomType.description}</BodyText>}
      {!!roomType.amenities?.length && (
        <Group direction="vertical" gap={12}>
          <BodyText variant={size} weight="bold">{intl.formatMessage({
            id: 'nA94DrRuGnawPqbfFT_m',
            defaultMessage: 'Room Facilities',
          })}
          </BodyText>
          <List>
            {roomType.amenities.map(amenity =>
              <BodyText key={amenity.id} as="li" variant={size}>{amenity.description}</BodyText>,
            )}
          </List>
        </Group>
      )}
    </Group>
  )
}

export default memo(LePackageUpgradeCardRoomDetails)
